export const ACTION_NAME = {
  DELETE: 'delete',
  RESUBMIT: 'resubmit',
};
